import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Agrotourismmorachichincholi() {



    const cardData =
    {
        keyword: 'Agro Tourism Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: Agro Tourism Morachi Chincholi',
        headingDescription: 'Experience the charm of rural Maharashtra with a delightful one-day getaway at Anand Krushi Paryatan Kendra, a 40-acre agri-tourism destination in Morachi Chincholi, just 55 km from Pune. Perfect for families, school groups, and corporate outings, this scenic location is a top choice for Agro Tourism Morachi Chincholi. The farm offers a wide range of engaging rural activities such as bullock cart and tractor rides, horse riding, boating, and a rain dance zone. Adventure and traditional village games keep everyone entertained, while magic and puppet shows add a cultural touch to the experience.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Early Morning Tractor Safari",
    "description": "Kickstart your rural retreat with a breezy tractor safari through expansive farmlands, vibrant marigold patches, and swaying mustard fields. This scenic ride offers panoramic views of the countryside, a chance to interact with local farmers, and moments to capture Instagram-worthy sunrise photos — all while sitting on a colorfully decorated traditional tractor."
  },
  {
    "title": "Hands‑On Organic Farming Experience",
    "description": "Participate in hands-on farming where you can sow seeds, pluck seasonal vegetables, and try composting methods used by real village farmers. Learn how organic food is grown using traditional techniques like bullock-ploughing, mulching, and drip irrigation. This immersive session fosters a deeper connection with the soil, and kids especially love digging in and discovering where their food comes from."
  },
  {
    "title": "Village‑Style Breakfast Feast",
    "description": "After working up an appetite, enjoy a farm-fresh breakfast made with love—think spicy misal-pav, tangy thecha served with bhakri, sabudana khichdi, and piping hot tea brewed over a wood-fired chulha. Served in a bamboo-covered seating area surrounded by lush greenery, this meal offers both nutrition and nostalgia, making it a highlight of your visit."
  },
  {
    "title": "Rural Games & Family Fun",
    "description": "Revisit your childhood with traditional Indian games like gilli-danda, lagori, kabaddi, kho-kho, and sack races. Large open grounds allow everyone to freely play, laugh, and bond—be it kids discovering new games or adults reliving theirs. The kendra also provides bamboo swings, rope walks, and tire-balancing zones to keep all age groups joyfully engaged."
  },
  {
    "title": "Nature Trail & Bird Watching",
    "description": "Wander along well-marked nature trails that weave through the farm’s outskirts and observe native flora and fauna in peace. Early morning or late afternoon strolls often include glimpses of parrots, kingfishers, bulbuls, and even peacocks fluttering by the banyan and tamarind trees. It’s a perfect activity for bird lovers and peace seekers alike."
  },
  {
    "title": "Interactive Dairy & Milking Demo",
    "description": "Witness and participate in the milking of cows using age-old hand techniques, guided by the farm's caretakers. Learn how milk is filtered, boiled, and turned into ghee or curd. Children especially enjoy feeding the calves or watching buffaloes bathe in the nearby pond — offering a wholesome view of rural dairy life that's both educational and fun."
  },
  {
    "title": "Rustic Lunch on Banana Leaves",
    "description": "Feast on an unlimited Maharashtrian thali served with love on fresh-cut banana leaves — featuring dishes like zunka-bhakar, bharli vangi, pithla, varan-bhat, pickles, and cooling taak. The authentic taste is enhanced by open-air seating, folk music, and a backdrop of swaying sugarcane fields. A truly soulful rural lunch that satisfies both your palate and heart."
  },
  {
    "title": "Craft Workshop: Pottery & Weaving",
    "description": "Join hands-on workshops where local artisans teach you the art of clay pottery, mud toys, and traditional weaving with banana fiber or jute. Paint your own diyas or make a tiny pot on the wheel, and take home a handcrafted souvenir made by you. These sessions are perfect for kids, creative adults, and couples seeking a unique, memorable experience."
  },
  {
    "title": "Water Splash Zone & Rain Dance",
    "description": "Unwind in the dedicated splash zone equipped with water jets, kiddie pools, and colorful slides. Groove under the rain dance canopy with lively Marathi beats or Bollywood DJ remixes. It’s a great way to cool off after a day of activities—especially loved by children and young adults during weekends, summer holidays, and group outings."
  },
  {
    "title": "Sunset Nature Stroll & Bonfire",
    "description": "As the sun sets behind the sugarcane fields, take a golden-hour stroll around the property or rest beneath the banyan tree to watch the sky change colors. Later, gather around a cozy bonfire with your group for folk tales, live music, bhadang-snacks, or even dholki singing. A soothing close to a lively rural day, perfect for creating lasting memories."
  }
],




"services": [
  {
    "name": "Agro Tourism Farms Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is among the top agro tourism farms near Morachi Chincholi, offering authentic rural experiences in a peaceful, natural setting. Guests can enjoy farming demos, nature walks, cultural events, and birdwatching—all in one day."
  },
  {
    "name": "Organic Farming Experiences",
    "description": "Explore chemical-free farming methods used at Anand Krushi Paryatan Kendra. Learn about composting, seed conservation, and sustainable soil practices that support health and the environment through immersive organic farming sessions."
  },
  {
    "name": "Farm Stays with Activities",
    "description": "Stay overnight in rustic yet comfortable cottages amidst green fields. Enjoy daily farm chores, evening bonfires, local meals, and cultural shows—all designed to immerse you in farm life near Morachi Chincholi."
  },
  {
    "name": "Educational Farm Tours",
    "description": "Perfect for schools and educational groups, Anand Krushi Paryatan Kendra offers farm tours that teach kids and adults about traditional agriculture, biodiversity, and eco-friendly practices through interactive, hands-on experiences."
  },
  {
    "name": "Local Food Tasting on Farms",
    "description": "Relish traditional Maharashtrian dishes made from ingredients grown right on the farm. Guests love the simplicity and flavor of bhakri, pitla, thecha, and seasonal specialties like aamras served fresh and hot from farm kitchens."
  },
  {
    "name": "Nature Trails Through Farms",
    "description": "Wander through well-maintained nature trails surrounded by mango orchards, vegetable patches, and flowering shrubs. The trails at Anand Krushi Paryatan Kendra are peaceful and ideal for nature lovers, photographers, and bird watchers."
  },
  {
    "name": "Cultural and Traditional Farm Events",
    "description": "Celebrate rural culture through folk music, bullock cart rides, and festive events like Sankranti and Holi at the farm. These cultural activities give visitors a unique and engaging look into the traditions of Maharashtra's villages."
  },
  {
    "name": "Bird Watching on Farms",
    "description": "Morachi Chincholi is famous for its peacocks, and Anand Krushi Paryatan Kendra offers a prime spot to observe these birds in the wild. Early mornings and evenings are perfect for birdwatching among the farm's trees and open spaces."
  },
  {
    "name": "Family-Friendly Agro Tourism Spots",
    "description": "Families with kids will love Anand Krushi Paryatan Kendra’s safe and engaging environment. With interactive farming zones, play areas, and rural games, it's a perfect place for a wholesome family day out near Pune."
  },
  {
    "name": "Workshops on Farming Techniques",
    "description": "Join informative workshops that cover organic farming, irrigation methods, composting, and natural pest management. These sessions are ideal for students, eco-tourists, and aspiring farmers seeking practical knowledge."
  },
  {
    "name": "Adventure Activities on Farms",
    "description": "In addition to peaceful walks, the farm offers rustic adventure activities such as rope bridges, tire walks, climbing frames, and other outdoor games. It’s a fun way to experience rural life with an adventurous twist."
  },
  {
    "name": "Sustainable Farming Experiences",
    "description": "Anand Krushi Paryatan Kendra practices sustainable agriculture through rainwater harvesting, crop rotation, and eco-friendly infrastructure. Guests can explore these practices and understand how rural farms contribute to environmental health."
  },
  {
    "name": "Farm Produce Markets",
    "description": "Buy fresh and organic produce directly from the source. The farm market features vegetables, fruits, pickles, grains, jaggery, and seasonal specialties like mangoes—all grown and processed onsite."
  },
  {
    "name": "Guided Agro Tours",
    "description": "Knowledgeable guides walk guests through the full farming cycle—from soil preparation to harvest. These guided tours are insightful, educational, and a great way to appreciate the hard work behind your food."
  },
  {
    "name": "Weekend Agro Tourism Packages",
    "description": "Plan a full weekend at Anand Krushi Paryatan Kendra with all-inclusive packages that include meals, farm activities, cultural entertainment, and cozy stays. Ideal for couples, families, school groups, or anyone seeking a nature-filled getaway."
  }
],
"tableData": [
  ["Agro Tourism Farms Near Morachi Chincholi", "- Organic Farming Experiences"],
  ["Farm Stays with Activities", "- Educational Farm Tours"],
  ["Local Food Tasting on Farms", "- Nature Trails Through Farms"],
  ["Cultural and Traditional Farm Events", "- Bird Watching on Farms"],
  ["Family-Friendly Agro Tourism Spots", "- Workshops on Farming Techniques"],
  ["Adventure Activities on Farms", "- Sustainable Farming Experiences"],
  ["Farm Produce Markets", "- Guided Agro Tours"],
  ["Weekend Agro Tourism Packages", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Close Proximity to Pune",
    "WhyChoosedescription": "Just 55 km from Pune via the scenic Pune–Ahmednagar roadway, Anand Krushi Paryatan Kendra offers an easy and refreshing escape—reaching rural tranquillity within a 1–1.5 hour drive."
  },
  {
    "WhyChooseheading": "Living Peacock Sanctuary",
    "WhyChoosedescription": "Situated in Morachi Chincholi’s famed tamarind groves, the site is home to thousands of peacocks roaming freely—offering breathtaking encounters with these majestic birds in their natural habitat."
  },
  {
    "WhyChooseheading": "Interactive Farm Learning",
    "WhyChoosedescription": "Visitors can engage in authentic farming experiences, from bullock-cart and tractor rides to hands-on work in organic vegetable and fruit plots, plus educational sessions on irrigation and crop cycles."
  },
  {
    "WhyChooseheading": "Fun Rural Experiences for All Ages",
    "WhyChoosedescription": "The centre features puppet and magic shows, traditional games (like gilli‑danda and lagori), animal feeding zones, and play areas—making it enjoyable for children, adults, and seniors alike."
  },
  {
    "WhyChooseheading": "Outdoor Adventure & Recreation",
    "WhyChoosedescription": "Thrill seekers can enjoy zip‑lining, archery, rope‑climbing, boating by the pond, and casual sports like cricket and volleyball—plus a rain‑dance arena to beat the heat in summer."
  },
  {
    "WhyChooseheading": "Seasonal Village Festivals & Cultural Immersion",
    "WhyChoosedescription": "Celebrate with local festivals such as Hurda gatherings in winter and the Mango Mahotsav in summer—featuring fresh farm produce, folk performances, lantern nights, and rustic village feasts."
  },
  {
    "WhyChooseheading": "Wholesome Farm-to-Table Dining",
    "WhyChoosedescription": "Savour farm-fresh Maharashtrian delicacies prepared using organic produce grown on site—jowar bhakri, crisp salads, misal-pav, seasonal veggies, homemade butter and desserts served in a natural setting."
  },
  {
    "WhyChooseheading": "Affordable Holistic Packages",
    "WhyChoosedescription": "Value-packed day tours start at around ₹600 for adults and ₹300 for children and include activities, meals and rides, with optional overnight camping and stargazing packages available for those seeking more immersion."
  }
]










    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What is agro tourism in Morachi Chincholi?',
    answer: 'Agro tourism in Morachi Chincholi combines rural life with tourism by offering experiences like farm tours, bullock cart rides, peacock sightings, and traditional village activities just 65 km from Pune.',
  },
  {
    id: 'FAQ2',
    question: 'Why is Morachi Chincholi famous for agro tourism?',
    answer: 'It’s known for its high peacock population, lush farms, and agritourism centers like Anand Krushi Paryatan Kendra that offer authentic village experiences to tourists.',
  },
  {
    id: 'FAQ3',
    question: 'What are typical activities offered at agro tourism spots here?',
    answer: 'Activities include tractor and bullock cart rides, butterfly watching, crop tours, feeding animals, milking cows, village games, and enjoying home-cooked Maharashtrian meals.',
  },
  {
    id: 'FAQ4',
    question: 'Is it a good place for kids and families?',
    answer: 'Yes! Children enjoy the open spaces, animals, and interactive experiences, while parents relax and enjoy nature. It’s educational and fun for all age groups.',
  },
  {
    id: 'FAQ5',
    question: 'Can schools and colleges arrange educational trips here?',
    answer: 'Absolutely. Agro tourism centers offer packages for schools, with guided tours explaining farming techniques, ecology, and rural life.',
  },
  {
    id: 'FAQ6',
    question: 'Is accommodation available at these centers?',
    answer: 'Most offer day-visit packages, but some like Anand Krushi provide basic overnight stay options with eco-friendly lodging.',
  },
  {
    id: 'FAQ7',
    question: 'When is the best time to visit?',
    answer: 'The monsoon and early winter months (June to November) are best for greenery, pleasant weather, and active peacock sightings.',
  },
  {
    id: 'FAQ8',
    question: 'How do I reach Morachi Chincholi from Pune?',
    answer: 'It’s a 1.5-hour drive via Alandi or Chakan. Private vehicle or cab is the most convenient way to reach.',
  },
  {
    id: 'FAQ9',
    question: 'What should I bring for an agro tourism trip?',
    answer: 'Wear comfortable clothes, bring sun protection, water bottles, insect repellent, a camera, and your own picnic mat if you plan to relax on the grass.',
  },
  {
    id: 'FAQ10',
    question: 'Do I need to book in advance?',
    answer: 'Yes, especially on weekends and holidays. Pre-booking ensures a slot for rides, meals, and group activities.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Leena Phadke, Pune',
    feedback: "Agro tourism at Morachi Chincholi was a breath of fresh air! My kids loved the bullock cart ride and feeding animals. It was both relaxing and educational.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Nitin Gawade, Teacher, Lonavala',
    feedback: "We took our school students to Morachi Chincholi, and they were amazed by the farm life and peacocks. It was the perfect hands-on learning day!",
    rating: 5,
  },
];











    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Agro Tourism Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/agro-tourism-morachi-chincholi.jpg",
  "description": "Experience authentic agro tourism in Morachi Chincholi with Anand Krushi Paryatan Kendra. Enjoy organic farming, bird watching, traditional farm events, nature trails, and weekend farm stay packages for families and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2314"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "650",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/agro-tourism-morachi-chincholi"
  }
};




    return (
        <div>
<Helmet>
  <title>Agro Tourism Morachi Chincholi | Farm Stays, Nature Trails & Organic Food | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Discover the charm of agro tourism at Morachi Chincholi with Anand Krushi Paryatan Kendra. Explore nature trails, farming workshops, bird watching, family-friendly farm activities, and local organic food experiences." 
  />
  <meta 
    name="keywords" 
    content="Agro tourism farms near Morachi Chincholi, Organic farming experiences, Farm stays with activities, Educational farm tours, Local food tasting on farms, Nature trails through farms, Cultural and traditional farm events, Bird watching on farms, Family-friendly agro tourism spots, Workshops on farming techniques, Adventure activities on farms, Sustainable farming experiences, Farm produce markets, Guided agro tours, Weekend agro tourism packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Agrotourismmorachichincholi;